import { H5, LI, UL } from '../../../../AbstractElements'
import { CardType } from '../../../../Types/Application/Users/UsersProfile'

const UserCardsFooter: React.FC<CardType> = ({ item }) => {
  return (
    <UL className="social-follow d-block">
      <LI>
        <H5 className="mb-0">#{item.id}</H5>
        <span className="f-light">ID Usuario</span>
      </LI>
      <LI>
        <H5 className="mb-0">{item.follower}</H5>
        <span className="f-light">Estado</span>
      </LI>
      <LI>
        <H5 className="mb-0">{item.following}</H5>
        <span className="f-light">Rol</span>
      </LI>
    </UL>
  )
}

export default UserCardsFooter